import { Spin } from 'antd';
import ReactDOM from 'react-dom';
import './global-loading.css'; // 样式文件

const GlobalSpinLoading = ({ visible, text = '加载中...' }) => {
  if (!visible) return null;

  return ReactDOM.createPortal(
    <div className="global-spin-container">
      {/* 遮罩层 */}
      <div className="global-spin-mask" />
      
      {/* 加载内容 */}
      <div className="global-spin-content">
        <Spin size="large" tip={text} />
      </div>
    </div>,
    document.body // 挂载到 body，确保在最上层
  );
};

export default GlobalSpinLoading;